module.exports = "<h1>{{ 'EDIT_USERNAME' | translate }}</h1>\n<hr>\n\n<div class=\"modal-content\">\n  <input class=\"form-control\" [(ngModel)]=\"userName\" #ctrl=\"ngModel\" required>\n</div>\n\n<div class=\"right\">\n  <button class=\"btn btn-secondary\" (click)=\"onCancelClick()\">{{ 'CANCEL' | translate }}</button>\n  <button class=\"btn btn-primary\" (click)=\"onSaveClick()\">{{ 'SAVE' | translate }}</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/admin/components/myaccount/components/edit-user/edit-user.component.html
// module id = 1408
// module chunks = 0